var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options-correct-order"},[_c('div',{staticClass:"section"},[_c('QuizOption',{class:{
        'timeout': _vm.isAnswerTimeout,
        'correct': _vm.isAnswerCorrect,
        'incorrect': !_vm.isAnswerCorrect && !_vm.isAnswerTimeout,
        'checked': !_vm.isAnswerTimeout,
      },attrs:{"option":{ title: _vm.quizStatusText },"hasCheckbox":false}})],1),_c('div',{staticClass:"section-title"},[_vm._v("\n    "+_vm._s(_vm.$t('correctAnswerTitle'))+"\n  ")]),_c('div',{staticClass:"correct-order-group"},_vm._l((_vm.slideOptions),function(option,index){return _c('QuizOption',{key:option.id,class:{
        'massive': _vm.isMassiveOptions,
        'border-none': true,
      },attrs:{"index":index + 1,"option":option,"hasCheckbox":false,"indexed":true}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }